module.exports = __webpack_public_path__ + "edcba0bd8e15653d38be838ebf58ba53.pdf";